"use client";

import { Button } from "../ui/button";

interface SpotlightLabelProps {
  hint: string;
  onNext: () => void;
  onPrev: () => void;
  onFinish: () => void;
  isFirst: boolean;
  isLast: boolean;
  currentStep: number;
  totalSteps: number;
}

const SpotlightLabel = ({
  hint,
  onNext,
  onPrev,
  onFinish,
  isFirst,
  isLast,
  currentStep,
  totalSteps,
}: SpotlightLabelProps) => {
  return (
    <div
      className=" z-[1001] bg-[#081121] border border-[--accent-primary] text-[#b1bcc7] px-4 py-3 rounded-md shadow-lg max-w-[380px] w-max whitespace-pre-wrap break-words text-sm"
      style={{}}
    >
      <p>{hint}</p>

      <div className="mt-4 flex justify-between gap-2">
        <div>{`Step ${currentStep} of ${totalSteps}`}</div>
        <div className="flex gap-2">
          {!isFirst && (
            <Button
              size="sm"
              variant="secondary"
              className="border-white text-white hover:bg-white/10"
              onClick={onPrev}
            >
              Prev
            </Button>
          )}
          <Button
            size="sm"
            variant="default"
            onClick={isLast ? onFinish : onNext}
            className="bg-[--accent-primary] hover:bg-[--accent-primary] text-white"
          >
            {isLast ? "Finish" : "Next"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SpotlightLabel;
